const Style = ({ attributes, clientId }) => {
	const { alignment, padding } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#sbbSkypeButton-${clientId}{
			text-align: ${alignment};
		}
		#sbbSkypeButton-${clientId} .sbbSkypeButton{
			padding: ${padding?.styles ?? '0'};
		}
		`.replace(/\s+/g, ' ')
	}} />;
}
export default Style;